function Loader(props){
    return <div className="loader-holder">
        <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
}

export default Loader;